import React from 'react';
import PropTypes from 'prop-types';

import { Link as RouterLink, useLocation } from 'react-router-dom';
import { LeftCircleTwoTone, RightCircleTwoTone } from '@ant-design/icons';
import moment from 'moment-timezone';
import qs from 'qs';

import { ReactorType } from '../../../utils/types';

import ReactorLoadChart from './ReactorLoadChart';

function ProductionTab({ reactor, currentDate }) {
  const location = useLocation();

  console.log('ProductionTab render:', {
    reactorName: reactor.name,
    currentDate,
    dayProductions: reactor.dayProductions?.length || 0,
    currentLocation: location.pathname + location.search,
  });

  // Calculate previous and next dates for debugging
  const previousDate = moment(currentDate)
    .subtract(1, 'day')
    .startOf('hour')
    .toISOString();
  const nextDate = moment(currentDate)
    .add(1, 'day')
    .startOf('hour')
    .toISOString();

  console.log('ProductionTab navigation dates:', {
    currentDate,
    previousDate,
    nextDate,
    canGoPrevious: moment(currentDate).isAfter('2012-01-02'),
    canGoNext: !moment().isSame(currentDate, 'day'),
  });

  // Build URLs for navigation
  const previousUrl = `${location.pathname}?${qs.stringify({
    date: previousDate,
  })}#production`;
  const nextUrl = `${location.pathname}?${qs.stringify({
    date: nextDate,
  })}#production`;

  console.log('ProductionTab navigation URLs:', {
    currentUrl: location.pathname + location.search,
    previousUrl,
    nextUrl,
  });

  return (
    <div>
      <ReactorLoadChart
        key={`${reactor.name}-${currentDate}`}
        reactor={reactor}
        currentDate={currentDate}
      />
      <div className="MixView__date">
        {moment(currentDate).isAfter('2012-01-02') ? (
          <RouterLink to={previousUrl}>
            <LeftCircleTwoTone style={{ fontSize: '18pt' }} />
          </RouterLink>
        ) : (
          <div />
        )}
        <div>{moment(currentDate).format('DD/MM/YYYY')}</div>
        {!moment().isSame(currentDate, 'day') ? (
          <RouterLink to={nextUrl}>
            <RightCircleTwoTone style={{ fontSize: '18pt' }} />
          </RouterLink>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

ProductionTab.propTypes = {
  reactor: ReactorType.isRequired,
  currentDate: PropTypes.string.isRequired,
};

export default ProductionTab;
